
import services from '~/services'
import InformationFormOneForm from './Form.vue'
import ProductSelect from './ProductSelect.vue'
export default {
  components: {
    ProductSelect,
    InformationFormOneForm,
  },
  data() {
    return {
      selectedProducts: [],
    }
  },
  methods: {
    REMOVE_SELECT(index) {
      this.selectedProducts.splice(index, 1)
    },
    SET_SELECT(product) {
      document.getElementById('form-area').scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
      const index = this.selectedProducts.findIndex(
        (item) => item.id === product.id
      )

      if (index === -1) this.selectedProducts.push(product)
    },
    GET_SELECT_FROM_QUERY() {
      const query = this.$route.query
      if (query.product) {
        const response = services.products.getBySlug(query.product)
        if (response.id) {
          this.SET_SELECT(response)
          setTimeout(() => {
            document.getElementById('name')?.focus()
          }, 750)
        }
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.GET_SELECT_FROM_QUERY()
    }, 250)
  },
}
